import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
// import loggerMiddleware from 'redux-logger';

import RootReducer from './reducers';

let configureStore;

//If the app is running in dev, add in redux dev tools
configureStore = initialState => {
  const store = createStore(
    RootReducer,
    initialState,
    applyMiddleware(thunkMiddleware)
  );

  return store;
}

export default configureStore;
